import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextArea } from '@driftt/tide-core'
import { debounce } from 'lodash'
import './style.css'

const UPDATE_DELAY_IN_MS = 300


class SubmissionNotes extends Component {
  static propTypes = {
    appId: PropTypes.string.isRequired,
    updateNotes: PropTypes.func.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      notes: props.notes
    }
  }

  onNotesUpdated = (notes) => {
    const { updateNotes, showErrorNotification } = this.props

    updateNotes(notes)
      .catch(() => showErrorNotification('Oops, we couldn’t save your notes. Please make a change to try again.'))
  }

  onNotesUpdatedDebounced = debounce(this.onNotesUpdated, UPDATE_DELAY_IN_MS)

  render() {
    const { notes } = this.state

    return (
      <div className="app-submit-view-accordion-content">
        <p className="app-submit-view-accordion-content-description">
          If you want to provide any other information or details about your app, you can go ahead and do that here! If not, don’t worry - this step is optional.
        </p>
        <TextArea
          className="app-submission-notes-textarea"
          label="App Submission Notes"
          text={notes}
          onChange={(notes) => this.onNotesUpdatedDebounced(notes.target.value)}
        />
      </div>
    )
  }
}

export default SubmissionNotes
